/**
 * Analyysisivun osiot — sama oletus kuin AdminSettings.
 */

export const DEFAULT_ANALYTICS_SECTIONS = [
  { id: 'summary', name: 'Yhteenveto', visible: true, expanded: true, order: 0 },
  { id: 'longestGames', name: 'Pisimmät pelit', visible: true, expanded: true, order: 1 },
  { id: 'mostPlayed', name: 'Suosituimmat pelit', visible: true, expanded: true, order: 2 },
  { id: 'winRates', name: 'Voittoprosentit', visible: true, expanded: true, order: 3 },
  { id: 'winStreaks', name: 'Voittoputket', visible: true, expanded: false, order: 4 },
  { id: 'highestScores', name: 'Korkeimmat pisteet', visible: true, expanded: false, order: 5 },
  { id: 'closestGames', name: 'Tasaisimmat pelit', visible: true, expanded: false, order: 6 },
  { id: 'playerFavorites', name: 'Pelaajien suosikit', visible: true, expanded: false, order: 7 },
  { id: 'monthlyActivity', name: 'Kuukausiaktiivisuus', visible: true, expanded: false, order: 8 },
  { id: 'headToHead', name: 'Keskinäiset kohtaamiset', visible: true, expanded: false, order: 9 },
  { id: 'avgPointsPerGame', name: 'Keskimääräinen menestyspisteansio', visible: true, expanded: true, order: 10 },
  { id: 'pointsLeaderboard', name: 'Menestyspisteet', visible: true, expanded: true, order: 11 },
  { id: 'medalPercentage', name: 'Mitalisijoitus-%', visible: true, expanded: true, order: 12 },
  { id: 'medalTable', name: 'Mitalitaulukko', visible: true, expanded: true, order: 13 }
];

function defaultById(id) {
  return DEFAULT_ANALYTICS_SECTIONS.find((section) => section.id === id);
}

/**
 * Combine saved club settings with current defaults.
 * Sections missing from storage (e.g. medal tables) are appended after the saved ones.
 */
export function mergeAnalyticsSections(savedSections) {
  const saved = Array.isArray(savedSections) ? savedSections : [];
  if (!saved.length) {
    return DEFAULT_ANALYTICS_SECTIONS.map((section) => ({ ...section }));
  }

  const seen = new Set();
  const merged = [];
  for (const section of saved) {
    if (!section?.id || seen.has(section.id)) continue;
    seen.add(section.id);
    const def = defaultById(section.id);
    merged.push({
      ...(def || {}),
      ...section,
      id: section.id,
      name: def?.name || section.name,
      visible: section.visible !== false,
      expanded: section.expanded === true,
      order: Number.isFinite(Number(section.order)) ? Number(section.order) : merged.length
    });
  }

  let nextOrder = merged.reduce((max, section) => Math.max(max, Number(section.order) || 0), -1) + 1;
  for (const def of DEFAULT_ANALYTICS_SECTIONS) {
    if (seen.has(def.id)) continue;
    merged.push({ ...def, order: nextOrder });
    nextOrder += 1;
  }
  return merged;
}

export function sortSectionsByOrder(sections) {
  return [...(sections || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function getOrderedVisibleSections(settings) {
  return sortSectionsByOrder(mergeAnalyticsSections(settings?.sections))
    .filter((section) => section.visible !== false);
}

export function buildExpandedMapFromSections(sections) {
  const o = {};
  DEFAULT_ANALYTICS_SECTIONS.forEach((section) => {
    o[section.id] = section.expanded === true;
  });
  (sections || []).forEach((section) => {
    o[section.id] = section.expanded === true;
  });
  return o;
}
